export default (color) => {
  return color && /(transparent)|(rgba\(\d+,\s*\d+,\s*\d+,\s*0\))/g.test(color);
};
